"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Pagination = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Pagination, _React$PureComponent);

  var _super = _createSuper(Pagination);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getPageTotal", function () {
      var _this$props = _this.props,
          total = _this$props.total,
          limit = _this$props.limit;
      return Math.ceil(total / limit);
    });

    _defineProperty(_assertThisInitialized(_this), "getItems", function () {
      var page = _this.props.page;
      var items = [];

      var itemsRange = _this.getItemsRange();

      for (var i = itemsRange.start; i <= itemsRange.end; i++) {
        items.push( /*#__PURE__*/_react["default"].createElement("li", {
          key: i,
          onClick: _this.handlePageChange(i),
          className: (0, _classnames["default"])({
            active: page === i
          })
        }, i));
      }

      return items;
    });

    _defineProperty(_assertThisInitialized(_this), "getItemsRange", function () {
      var _this$props2 = _this.props,
          page = _this$props2.page,
          itemsRangeDisplay = _this$props2.itemsRangeDisplay;

      var pageTotal = _this.getPageTotal();

      var range = itemsRangeDisplay - 1; // minus active page

      var leftRange = Math.ceil(range / 2);
      var rightRange = range - leftRange;
      var startPage;
      var endPage;

      if (page <= leftRange) {
        startPage = 1;
        endPage = itemsRangeDisplay;
      } else if (page + rightRange > pageTotal) {
        startPage = pageTotal - range;
        endPage = pageTotal;
      } else {
        startPage = page - leftRange;
        endPage = page + rightRange;
      }

      return {
        start: startPage < 1 ? 1 : startPage,
        end: endPage > pageTotal ? pageTotal : endPage
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getPrevPage", function () {
      var page = _this.props.page;
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          disabled: page === 1
        }),
        onClick: _this.handlePageChange(page - 1)
      }, "<");
    });

    _defineProperty(_assertThisInitialized(_this), "getNextPage", function () {
      var page = _this.props.page;
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          disabled: page === _this.getPageTotal()
        }),
        onClick: _this.handlePageChange(page + 1)
      }, ">");
    });

    _defineProperty(_assertThisInitialized(_this), "getFirstPage", function () {
      var page = _this.props.page;
      return /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          disabled: page === 1
        }),
        onClick: _this.handlePageChange(1)
      }, "<<");
    });

    _defineProperty(_assertThisInitialized(_this), "getLastPage", function () {
      var page = _this.props.page;

      var pageTotal = _this.getPageTotal();

      return /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          disabled: page === pageTotal
        }),
        onClick: _this.handlePageChange(pageTotal)
      }, ">>");
    });

    _defineProperty(_assertThisInitialized(_this), "getPagination", function () {
      var total = _this.props.total;
      if (!total || _this.getPageTotal() < 2) return null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "pagination-pages"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "pagination-controls"
      }, _this.getFirstPage(), _this.getPrevPage()), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "pagination-items"
      }, _this.getItems()), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "pagination-controls"
      }, _this.getNextPage(), _this.getLastPage()));
    });

    _defineProperty(_assertThisInitialized(_this), "getElementsCount", function () {
      var _this$props3 = _this.props,
          page = _this$props3.page,
          limit = _this$props3.limit,
          total = _this$props3.total,
          translatedText = _this$props3.translatedText;
      var from = (page - 1) * limit + 1;
      var to = page * limit > total ? total : page * limit;
      var itemsRange = from > 0 && to > 1 ? "".concat(from, " - ").concat(to) : "".concat(from);
      var text = "".concat(itemsRange, " ( ").concat(translatedText.of);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "pagination-elements-count"
      }, text, "\xA0", /*#__PURE__*/_react["default"].createElement("span", {
        className: "total-count"
      }, total), "\xA0)");
    });

    _defineProperty(_assertThisInitialized(_this), "handlePageChange", function (newPage) {
      return function (e) {
        var _this$props4 = _this.props,
            onChange = _this$props4.onChange,
            page = _this$props4.page;
        if (newPage === page) return;
        if (_this.props.onChange) return onChange({
          page: newPage
        });
        console.error('Nothing happened. Need to set onChange prop to Pagination'); // defaultHandle below

        e.preventDefault();
      };
    });

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var containerClassName = this.props.containerClassName;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('pagination-container', _defineProperty({}, containerClassName, Boolean(containerClassName)))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "pagination-pages-wrapper"
      }, this.getPagination()), this.getElementsCount());
    }
  }]);

  return Pagination;
}(_react["default"].PureComponent);

Pagination.propTypes = {
  page: _propTypes["default"].number,
  limit: _propTypes["default"].number,
  total: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  containerClassName: _propTypes["default"].string,
  itemsRangeDisplay: _propTypes["default"].number,
  translatedText: _propTypes["default"].object
};
Pagination.defaultProps = {
  page: 1,
  limit: 30,
  total: 0,
  containerClassName: '',
  itemsRangeDisplay: 5,
  translatedText: {
    of: 'of'
  }
};
var _default = Pagination;
exports["default"] = _default;